import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchReceivedAdsLwtdProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchReceivedAdsLwtd = (filters: FetchReceivedAdsLwtdProps) => void;

const fetchReceivedAdsLwtd = ({
  startDate,
  endDate,
  report
}: FetchReceivedAdsLwtdProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchReceivedAdsLwtd;
